"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const utils_1 = require("@/common/utils/utils");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'DynamicTitle',
    props: {
        title: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        withAdditional: {
            type: Boolean,
            default: false,
        },
        additional: {
            type: [String, Number],
            default: '',
        },
    },
    methods: {
        getClasses() {
            return [
                (0, utils_1.playerColorClass)(this.color, 'shadow'),
                'dynamic-title',
            ].join(' ');
        },
    },
});
